import { IntlShape } from 'react-intl';

import { Logger } from '../../../logger';

export const downloadExcelFile = (url: string, name: string) => {
  fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(blobUrl);
      document.body.removeChild(a);
    })
    .catch(error => {
      Logger.error('Error downloading file:');
      Logger.error(error);
    });
};

/**
 * Gets the formatted validation error message for excel uploads.
 * @param intl IntlShape
 * @param reasonMessage error reason message
 * @param sheetName sheet name mapping
 * @param sheet excel sheet
 * @param cell excel cell
 * @returns Formatted error message string
 */
export const getExcelValidationErrorMessage = (
  intl: IntlShape,
  reasonMessage: string,
  sheetName: Record<string, string>,
  sheet?: string,
  cell?: string
) => {
  return intl.formatMessage(
    {
      id: 'predict.excel_validation_error_description',
      defaultMessage:
        'There was a validation error in uploading this file. Please fix these reasons and upload the file again: {reason}{sheet}{cell}.'
    },
    {
      reason: reasonMessage,
      sheet: sheet
        ? ` ${intl.formatMessage(
            { id: 'predict.in_sheet', defaultMessage: '- in the sheet: {s}' },
            { s: sheetName[sheet] || sheet }
          )}`
        : '',
      cell: cell ? intl.formatMessage({ id: 'predict.excel_in_cell', defaultMessage: ', cell: {c}' }, { c: cell }) : ''
    }
  );
};
